var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#018489", fillRule: "evenodd", d: "M6.39 9h3.22c.642 0 1.233.369 1.561.965l.07.141.662 1.447c.287.63-.094 1.365-.712 1.44l-.105.007H4.914c-.642 0-1.073-.702-.858-1.341l.041-.106.661-1.447c.287-.63.852-1.044 1.485-1.1L6.391 9h3.218-3.218zM8 2c1.657 0 3 1.343 3 3S9.657 8 8 8 5 6.657 5 5s1.343-3 3-3z" })
  );
});